import React from 'react';
import classNames from "classnames";
import { LazyImage } from "component";
function ServicesCard(props) {
    var title = props.title, text = props.text, image = props.image, _a = props.altImage, altImage = _a === void 0 ? '' : _a, _b = props.reverse, reverse = _b === void 0 ? false : _b, icon = props.icon, _c = props.iconClassName, iconClassName = _c === void 0 ? '' : _c;
    var main = classNames({
        'flex flex-wrap shadow-lg hover:shadow-md rounded-md overflow-hidden': true,
        'flex-row': !reverse,
        'flex-row-reverse': reverse,
    });
    return (React.createElement("div", { className: main },
        image ?
            React.createElement("div", { className: 'relative w-full sm:w-1/2 md:w-2/5 pb-1/2 sm:pb-1/3' },
                React.createElement(LazyImage, { dataSrc: image, defaultImage: image, noScriptSrc: image, className: 'absolute top-0 right-0 w-full h-full object-cover object-center', alt: altImage })) : null,
        React.createElement("div", { className: 'flex flex-col justify-center w-full sm:w-1/2 md:w-3/5 px-5 lg:px-24 py-10' },
            icon ?
                React.createElement(LazyImage, { dataSrc: icon, defaultImage: icon, noScriptSrc: icon, className: iconClassName, alt: title })
                : null,
            React.createElement("div", { className: 'text-30 font-bold mb-5' }, title),
            React.createElement("div", { className: 'text-18 font-light leading-7 whitespace-pre-wrap break-word' }, text))));
}
export default ServicesCard;
